import React from "react";
import { RouteObject } from "react-router-dom";
import routePaths from "./../../constants/routes";
import ProtectedRoutes from "utils/ProtectedRoutes";
import Loader from "components/UI/Loader";

const Voicemail = React.lazy(() => import("../../pages/Voicemail"));

export const voicemailRoutes: RouteObject[] = [
	{
		path: routePaths.VOICEMAIL.__PATH,
		element: (
			<ProtectedRoutes>
				<React.Suspense fallback={<Loader />}>
					<Voicemail />
				</React.Suspense>
			</ProtectedRoutes>
		),
	},
];
